import { render, staticRenderFns } from "./megaMenu.vue?vue&type=template&id=21af6471&"
import script from "./megaMenu.vue?vue&type=script&lang=js&"
export * from "./megaMenu.vue?vue&type=script&lang=js&"
import style0 from "./megaMenu.vue?vue&type=style&index=0&id=21af6471&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21af6471')) {
      api.createRecord('21af6471', component.options)
    } else {
      api.reload('21af6471', component.options)
    }
    module.hot.accept("./megaMenu.vue?vue&type=template&id=21af6471&", function () {
      api.rerender('21af6471', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/megaMenu.vue"
export default component.exports